import * as React from 'react';
import { SvgInfoCircular } from './SvgInfoCircular.js';
import { SvgStatusError } from './SvgStatusError.js';
import { SvgStatusSuccess } from './SvgStatusSuccess.js';
import { SvgStatusWarning } from './SvgStatusWarning.js';
export const StatusIconMap = {
  negative: (args) =>
    React.createElement(SvgStatusError, {
      'aria-hidden': true,
      ...args,
    }),
  positive: (args) =>
    React.createElement(SvgStatusSuccess, {
      'aria-hidden': true,
      ...args,
    }),
  warning: (args) =>
    React.createElement(SvgStatusWarning, {
      'aria-hidden': true,
      ...args,
    }),
  informational: (args) =>
    React.createElement(SvgInfoCircular, {
      'aria-hidden': true,
      ...args,
    }),
};
